<template>

	<div class="wizard-component review">

		<div class="box">
			<p class="subject">Property</p>
			<div class="info">
				<div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21.984" height="20" viewBox="0 0 43.969 40">
                    	<path class="fill-purple" d="M102.016,406.991a4,4,0,1,0-4-4A4,4,0,0,0,102.016,406.991Zm-2,3.751a8.027,8.027,0,0,1-4.993-11.621,7.8,7.8,0,0,1,4.894-3.87,8.012,8.012,0,1,1,4.1,15.491V415H114V398.984a2,2,0,0,1,2-2h0.788l-14.778-13.321L87.235,396.983h0.787a2,2,0,0,1,2,2V415h4a2,2,0,0,1,0,4h-6a2,2,0,0,1-2-2V400.986h-4a2,2,0,0,1-1.337-3.489l19.986-18.014a2,2,0,0,1,2.674,0L123.335,397.5A2,2,0,0,1,122,400.986h-4V417a2,2,0,0,1-2,2h-13.99a2,2,0,0,1-2-2v-6.256Z" transform="translate(-80.031 -379)"/>
                    </svg>
                </div>
                <p v-if="property.address">{{ property.address }}</p>
                <p v-else>{{ noInput }}</p>
			</div>
			<div class="info">
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 36 36">
					  <path class="fill-purple" d="M1363,786.023h-6v-2a2,2,0,0,0-4,0v2h-12v-2a2,2,0,0,0-4,0v2h-6a2,2,0,0,0-2,2v3a2,2,0,1,0,4,0v-1h4v2a2,2,0,1,0,4,0v-2h12v2a2,2,0,1,0,4,0v-2h4V809.2l-4.83,4.828H1333v-14h24a2,2,0,0,0,0-4h-26a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2h26a1.983,1.983,0,0,0,1.41-.586l6-6a1.982,1.982,0,0,0,.59-1.414v-22A2,2,0,0,0,1363,786.023Z" transform="translate(-1329 -782.031)"/>
					</svg>
				</div>
				<p v-if="property.occupancyDate">Occupancy date: {{ property.occupancyDate }}</p>
				<p v-else>{{ noInput }}</p>
			</div>
		</div>
		<div class="box">
			<p class="subject">Tenants</p>
			<div class="info" v-if="tenants" v-for="tenant in tenants">
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="17.984" height="18" viewBox="0 0 35.969 36">
                        <path class="fill-purple" d="M102,297a4,4,0,1,0-4-4A4,4,0,0,0,102,297Zm5.04,2.211,2.02,2.02,7.523,2.3a2,2,0,0,1,1.393,1.619l2,13.556a2,2,0,0,1-1.686,2.271A2.038,2.038,0,0,1,118,321H86.01a2,2,0,0,1-1.98-2.29l1.992-13.554a2,2,0,0,1,1.224-1.562l6-2.446a2,2,0,0,1,1.508,3.7l-4.94,2.014L88.324,317H115.68l-1.48-10.012-6.79-2.077a1.987,1.987,0,0,1-.828-0.5l-3.488-3.488a8,8,0,1,1,3.944-1.712h0Z" transform="translate(-84 -285)"/>
                    </svg>
				</div>
				<p>{{ tenant.name }}</p>
			</div>
			<div class="info" v-else>
				<p>{{	noInput		}}</p>
			</div>
		</div>
		<div class="box calculate">
			<div class="content">
				<p class="subject">Payments before occupancy date</p>
				<div class="info">
					<p>Deposit</p>
					<p>{{ deposit }} DKK</p>
				</div>
				<div class="info">
					<p>Prepaid rent</p>
					<p>{{ prepaidRent }} DKK</p>
				</div>
				<div class="info">
					<p>First month´s rent</p>
					<p>{{ firstMonthRent }} DKK</p>
				</div>
				<div class="info">
					<p>First month´s a cont</p>
					<p>{{ firstMonthAcont }} DKK</p>
				</div>
			</div>
			<div class="content total">
				<div class="info">
					<p>Total</p>
					<p>{{ total }} DKK</p>
				</div>
			</div>
		</div>
		<div class="box preview-box" v-if="ready">
			<p class="subject">Contracts being sent</p>
			<div class="content">
				<div class="info">
					<div class="icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 32 40">
                          <path class="fill-purple" d="M96,612a2,2,0,0,1,0-4h8a2,2,0,1,1,0,4H96Zm0-16a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4H96Zm0,8a2,2,0,0,1,0-4h12a2,2,0,0,1,0,4H96Zm-6-18v34a2,2,0,0,1-4,0V584a2,2,0,0,1,2-2h20a2,2,0,0,1,1.415.586l8,8A2,2,0,0,1,118,592v28a2,2,0,0,1-2,2H96a2,2,0,0,1,0-4h18V592.827L107.174,586H90Z" transform="translate(-86 -582)"/>
                        </svg>
					</div>
					<p>Lease contract</p>
				</div>
				<a @click.prevent="exportPdf"><button class="purple">Preview</button></a>
			</div>
		</div>

	</div>

</template>


<script>

	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {

		methods: {
			async exportPdf() {

					await axios({
                        method: 'POST',
                        url: this.$root.apiUrl + 'api/contract/export/1',
						cancelToken: window.AuthorizationCancelSource.token,
                        data:{}
                    }).then(function(response) {
                    	window.open(response.data.exportUrl);
                    });
			}
		},

		data: () => ({

			noInput: 'Not specified yet',

			property: {
				address: 'Klingseyvej 15B, 2720 Vanløse',
				occupancyDate: '01-12-2018'
			},

			tenants: [
				{
					name: 'Simone Truelsen'
				}
			],

			deposit: '10.000',
			prepaidRent: '20.000',
			firstMonthRent: '10.000',
			firstMonthAcont: '800',
			total: '40.800',

			ready: true
		})

	}
</script>


<style></style>
